@if (shown) {
  <div
    class="tw-pt-5 purchase-interactive-license"
    rvSpinner="purchase-interactive-license-loader"
    [rvShowSpinner]="purchaseInteractiveService.loading"
  >
    @if (purchaseInteractiveService.apiError) {
      <notification-alert
        id="purchase-interactive-license-error"
        type="danger"
        [title]="purchaseInteractiveService.apiError"
        message="If you need help please email us at support@risevision.com"
        cssClass="u_margin-md-top"
      >
      </notification-alert>
    }
    @if (purchaseInteractiveService.estimate.estimateError) {
      <notification-alert
        id="purchase-interactive-license-estimate-error"
        type="danger"
        [title]="purchaseInteractiveService.estimate.estimateError"
        cssClass="u_margin-md-top"
      >
      </notification-alert>
    }

    <div id="purchase-interactive-license-panel" class="row">
      <div class="col-md-8 col-md-offset-2">
        <form
          [formGroup]="form"
          id="forms.purchaseInteractiveLicenseForm"
          role="form"
          novalidate
          (ngSubmit)="continue()"
        >
          <h4 class="u_margin-md-bottom">Purchase Details</h4>
          <div class="border-container p-4">
            <div
              class="left-right-aligner purchase-interactive-license__quantity-row"
              [class.has-error]="
                form.controls.quantity.invalid && form.controls.quantity.touched
              "
            >
              <label for="interactiveLicenseQuantity" class="control-label mb-0"
                >Number of interactive licenses you want to add:</label
              >
              <rv-quantity
                id="interactiveLicenseQuantity"
                formControlName="quantity"
                [min]="quantityMin"
                [required]="true"
                class="tw-w-36"
                ariaLabel="Number of interactive licenses"
              ></rv-quantity>
            </div>

            <div
              class="left-right-aligner purchase-interactive-license__total-row mt-4"
            >
              <div>
                <p class="font-weight-bold mb-1">
                  Total number of interactive licenses for this subscription:
                </p>
                <p class="text-muted mb-0">
                  {{ purchaseInteractiveService.priceDescription }}
                </p>
              </div>
              <span class="purchase-interactive-license__total-count">{{
                purchaseInteractiveService.totalInteractiveLicensesForSubscription
              }}</span>
            </div>

            <div class="purchase-interactive-license__divider pt-4">
              <hr class="mb-0" />
            </div>

            <div class="pt-4">
              @if (!addCoupon) {
                <button
                  type="button"
                  id="addCouponLinkInteractive"
                  class="text-link d-block text-right purchase-interactive-license__coupon-action"
                  (click)="addCoupon = true"
                >
                  Add A Coupon Code
                </button>
              } @else {
                <div class="row">
                  <div class="col-md-8">
                    <label for="couponCodeInteractive" class="sr-only"
                      >Coupon code</label
                    >
                    <input
                      id="couponCodeInteractive"
                      type="text"
                      class="form-control"
                      name="couponCode"
                      [(ngModel)]="couponCode"
                      [ngModelOptions]="{ standalone: true }"
                      placeholder="Coupon code"
                    />
                  </div>
                  <div class="col-md-4">
                    <button
                      rv-button
                      variant="secondary"
                      type="button"
                      class="tw-w-full"
                      (click)="applyCouponCode()"
                    >
                      Apply
                    </button>
                  </div>
                </div>
                <button
                  type="button"
                  class="text-link d-inline-block mt-2 purchase-interactive-license__coupon-action"
                  (click)="clearCouponCode()"
                >
                  Clear coupon
                </button>
              }
            </div>

            <div class="pt-4">
              <p class="left-right-aligner mb-4">
                <span class="font-weight-bold">Amount due now:</span>
                <span>
                  <span class="u_margin-right text-subtle">{{
                    purchaseInteractiveService.estimate.currencyCode | uppercase
                  }}</span>
                  <span class="purchase-total">{{
                    purchaseInteractiveService.totalDue | currency
                  }}</span>
                </span>
              </p>
              @if (purchaseInteractiveService.estimate.nextRenewalDate) {
                <p class="left-right-aligner mb-0">
                  <span class="font-weight-bold"
                    >Next renewal on
                    {{
                      purchaseInteractiveService.estimate.nextRenewalDate
                        | date: 'd-MMM-yyyy'
                    }}:</span
                  >
                  <span>
                    <span class="u_margin-right text-subtle">{{
                      purchaseInteractiveService.estimate.currencyCode
                        | uppercase
                    }}</span>
                    <span class="purchase-total">{{
                      purchaseInteractiveService.estimate.nextRenewalTotal
                        | currency
                    }}</span>
                  </span>
                </p>
              }
            </div>
          </div>

          <div class="row u_margin-md-top mb-5">
            <div class="col-md-4 mb-2">
              <button
                rv-button
                variant="secondary"
                id="cancelButtonInteractive"
                type="button"
                class="tw-w-full"
                (click)="cancel()"
              >
                Cancel
              </button>
            </div>
            <div class="col-md-8">
              <button
                rv-button
                id="payButtonInteractive"
                type="submit"
                class="tw-w-full"
                [disabled]="form.invalid || purchaseInteractiveService.loading"
              >
                {{ purchaseInteractiveService.payButtonLabel }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
}
